import { z } from 'zod';

export const booleanQueryParamSchema = z
  .enum(['true', 'false'])
  .transform(v => v === 'true');

export const numberQueryParamSchema = z.preprocess(
  val => (val === '' ? undefined : val),
  z.coerce.number(),
);

export const integerQueryParamSchema = z.preprocess(
  val => (val === '' ? undefined : val),
  z.coerce.number().int(),
);
